<template>
  <div class="animated fadeIn list-of-advance">
    <b-card>
      <div slot="header">My Cash-Advance Settlement 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <!-- <b-button variant="primary mr-1" @click="approvalConfirm()" v-if="(use_wfservice==1)"><i class="fa fa-paper-plane"></i> Submit</b-button> -->
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>

            <b-input-group >
              <b-input-group-prepend><label>Trx Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" style="width:23% !important;"></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" style="width:23% !important;"></b-form-input>
                <b-input-group-prepend><span class="ml-2 pt-2">Outstand &nbsp;</span></b-input-group-prepend>
                <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.YesNoAll" style="padding:0 !important;"></b-form-select>
            </b-input-group>
        </b-col>
        <b-col lg="6">
              <b-row>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>Trx. Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="Settlement Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><label>Cash Adv. Owner</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.crewinfo" placeholder="Employee"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>                      

              <b-row>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>Cash Advance #</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomorAdv" placeholder="Request Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><label>Cash Advance Name</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.namaacc" placeholder="Account Name"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>            
              <b-row>
                <b-col lg="12" class="text-right" >
                    <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-col>
              </b-row>                      
        </b-col>
      </b-row>      
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(sttlDate)="data">
          {{ data.item.sttlDate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(jumlah)="data">
          <span v-if="((data.item.posting==0) && (data.item.final==0))" style="background-color:yellow;">           
              {{data.item.jumlah|numFormat}}
          </span>
          <span v-else> 
              {{data.item.jumlah|numFormat}}
          </span>
        </template>
        <template v-slot:cell(lebihkurang)="data">
          {{data.item.lebihkurang|numFormat('0,0.00')}}
          <span v-if="(data.item.cashvault>0)">(DB)</span>
          <span v-else>(CR)</span>
        </template>
        <template v-slot:cell(outstand)="data">
          {{data.item.outstand|numFormat}}
          <span v-if="(data.item.cashvault>0)">(DB)</span>
          <span v-else>(CR)</span>
        </template>
      </b-table>
      <b-row>
        <b-col cols="3">
          <b-input-group>
              <b-input-group-append><label class="mt-1">
                Showing
                {{(tblData.page - 1) * tblData.limit + 1}}
                to
                {{tblData.page * tblData.limit}}
                of
                {{tblData.total}}
                entries,    limit per page &nbsp;                   
                </label></b-input-group-append>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm"/>
          </b-input-group>
        </b-col>
        <b-col cols="6">
        </b-col>
        <b-col cols="3">      
                <b-pagination
                  align="right"
                  :total-rows="tblData.total"
                  :per-page="tblData.limit"
                  v-model="tblData.page"
                ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <!-- <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col lg="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglRequ" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="4">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglRequ" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-input-group >
              <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
              <b-form-input readonly v-model="model.crewinfo"></b-form-input>
          </b-input-group>
          <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
            <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal> -->

  </div>
</template>

<style lang="scss">
.list-of-advance {
}
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
// import task from "../../apis/task";
import advsettle from "../../apis/advsettle";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      // use_wfservice:this.$store.state.user.use_wfservice,
      // showApprovalConfirm: false,
      // approvalHistory:[],
      // file:null,
      // confirmNoFile:false,
      // showConfirmNoFile:'',
      // showApprovalCancelConfirm: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      uanguser: this.$store.state.user.matauang,
      model:{},
        items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        // tgl1:this.$store.state.user.tglaktif,
        // tgl2:this.$store.state.user.akhirbln,        
        sortBy: 'sttlDate',
        sortDesc: true,
        DimCol:'Dim1',outstand:'',
        crewkey:this.$store.state.user.crewkey,crewinfo:this.$store.state.user.full_name
      },
      dataList: {
        YesNoAll: dropdown.YesNoAll
      }      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "sttlDate",
            thStyle: "width:90px",
            label: "Trx. Date",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
          },
          {
            key: "nomorAdv",
            label: "Adv Request#",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "crewinfo",
            label: "Settled By",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "jumlah",
            label: "Settlement Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "lebihkurang",
            label: "Surplus/Minus",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "outstand",
            label: "Outstanding Surplus/Minus",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          }
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }

      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    addRequest(){
      router.push("payment/:id");
    },
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.advsttllist) {
            this.tblData[key] = filter.advsttllist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.advsttllist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;

      const list = await advsettle.list(this.tblData);      
      this.items=list;
      this.isLoading=false;
      return list;
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.nomrAdv= '';
        this.tblData.namaacc=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal','tgl1', 'tgl2','outstand', 'nomor', 'crewinfo', 'nomorAdv', 'namaacc'];
      let filtered = false;
      const advsttllist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              advsttllist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          advsttllist.page=this.tblData.page;
          advsttllist.limit=this.tblData.limit;
          advsttllist.sortBy=this.tblData.sortBy;
          advsttllist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.advsttllist=advsttllist;
          this.$store.commit("filter", filter);
      }
    },     
  add(){
      this.saveFilter();
      router.push({name :"advance.settlefrm", params: { crewkey: this.tblData.crewkey}});
    },
    edit: function() {
        if (this.model.advSttlKey) {
      this.saveFilter();
          router.push({name :'advance.settlefrm', params: { advSttlKey: this.model.advSttlKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.advSttlKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
        this.isLoading=true;
      await advsettle.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.advSttlKey==this.model.advSttlKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    // approvalConfirm: async function () {
    //     if (this.model.advSttlKey) {
    //         if (this.model.send2wf==1) {
    //           try {
    //             const data = await task.approvalhistory({key: this.model.advSttlKey});
    //             this.approvalHistory=data;                
    //           } catch (error) {
    //             if (error.message) {
    //                 toastr.error(error.message,'ERROR MESSAGE',10000);
    //             } else {
    //                 toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
    //             }                
    //           }
    //         }
    //         this.model.orderdate = this.model.orderdate ? moment(this.model.orderdate).format('YYYY-MM-DD') : '';
    //             this.showApprovalConfirm = true;
    //     } else {
    //         toastr.warn('Please select a row that want to be sent to workflow Approval!');
    //     }
    // }, 
    // approval: async function(evt){
    //     evt.preventDefault()
    //     try {
    //         const formData = new FormData();
    //         if (!(this.file)) {
    //           if (this.confirmNoFile==false){
    //             toastr.info('Send without attachment, are you sure?');
    //             this.showConfirmNoFile=true;
    //             return;
    //           }
    //         } else {
    //           formData.append('file', this.file);
    //           formData.append('filename', this.file.name);
    //         }
    //         formData.append('tablekey', this.model.advSttlKey);
    //         this.showApprovalConfirm = false;
    //         this.isLoading=true;
    //         const resp = await procure.approval(formData);
    //         this.model.send2wf=1;
    //         this.refresh();
    //         this.isLoading=false;
    //         if (resp.message) {
    //             toastr.warn(resp.message,'warning',10000);
    //         }
    //     } catch (error) {
    //         this.isLoading=false;
    //         if (error.message) {
    //             toastr.error(error.message,'ERROR MESSAGE',10000);
    //         } else {
    //             toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
    //         }
    //     }
    // },  
    // approvalUndo: async function(){
    //     this.isLoading=true;
    //     try {
    //         await procure.approvalUndo(this.model);
    //         this.model.send2wf=0;
    //         // this.model.approvalConfirm=0;
    //         this.refresh();
    //         this.isLoading=false;
    //     } catch (error) {
    //         this.isLoading=false;
    //         if (error.message) {
    //             toastr.error(error.message,'ERROR MESSAGE',10000);
    //         } else {
    //             toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
    //         }
    //     }
    // },  
    // printApproval: async function()
    // {
    //   if (this.model.advSttlKey) {
    //       this.isLoading=true;
    //       try {
    //           this.reportUrl= await task.approvalprint({key: this.model.advSttlKey});
    //           this.showReport=true;
    //           this.isLoading=false;
    //       } catch (error) {
    //           this.isLoading=false;
    //           if (error.message) {
    //               toastr.error(error.message);
    //           } else {
    //               toastr.error(JSON.stringify(error));
    //           }
    //       }
    //     } else {
    //         toastr.warn('Please select a row that want to be Printed!');
    //     }
    // },      
    print: async function()
    {
      if (this.model.advSttlKey) {
          try {
                this.showReport=true;
              this.reportUrl= await advsettle.printjv(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
          this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
            const response = await advsettle.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/advance/home");
    },    
  }
};
</script>
